import Vue from 'vue';

const settingsRepository = {
  list: () => Vue.$axios.get(`whatsapp/accounts/list`)
  .then(({data}) => data, (error) => console.log(error)),

  all: () => Vue.$axios.get(`whatsapp/accounts/all`)
  .then(({data}) => data, (error) => console.log(error)),

  get: (id) => Vue.$axios.get(`whatsapp/accounts/${id}`)
  .then(({data}) => data, (error) => console.log(error)),

  create: (name, webhookId) => {
    let data = new FormData();
    data.append('name', name);
    data.append('webhookId', webhookId);

    return Vue.$axios.post(`whatsapp/accounts/create`, data)
    .then(({data}) => data, (error) => console.log(error));
  },

  update: (id, name, webhookId) => {
    let data = new FormData();
    data.append('id', id);
    data.append('name', name);
    data.append('webhookId', webhookId);

    return Vue.$axios.post(`whatsapp/accounts/update`, data)
    .then(({data}) => data, (error) => console.log(error));
  },

  delete: (id) => {
    let data = new FormData();
    data.append('id', id);

    return Vue.$axios.post(`whatsapp/accounts/delete`, data)
    .then(({data}) => data);
  },
};

export default settingsRepository;
